import { XNoIcon } from "@minervaproject/fds";
import React from "react";

// TODO: replace all usages with FDS ErrorMessage
const ErrorMessage = ({ msg, msgStyles = { width: "400px" } }) => {
  if (!msg) return null;

  return (
    <p className="flex body-s mt1 items-center" style={{ color: "var(--red)" }}>
      <span style={msgStyles}>
        <XNoIcon style={{ marginRight: "4px", height: 12, width: 12 }} />{" "}
        <span id="js-error">{msg}</span>
      </span>
    </p>
  );
};

export { ErrorMessage };
